import { resolveDynamicFlag } from "@/utils/featureFlagOverride";

const APPLE_MESSAGES_CONNECT_FLAG_KEY = "VITE_FF_APPLE_MESSAGES_CONNECT";
const appleMessagesConnectEnvValue =
  import.meta.env.VITE_FF_APPLE_MESSAGES_CONNECT === "true";

export const isAppleMessagesConnectEnabled = () =>
  resolveDynamicFlag(
    APPLE_MESSAGES_CONNECT_FLAG_KEY,
    appleMessagesConnectEnvValue,
  );
